import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavigateNext = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_374_3029",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 9,
		y: 7,
		width: 7,
		height: 11,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.2904 12.3442L9.21733 8.27112C9.07886 8.13267 9.00803 7.95864 9.00483 7.74902C9.00161 7.53943 9.07244 7.36219 9.21733 7.21732C9.36219 7.07244 9.53783 7 9.74423 7C9.95063 7 10.1263 7.07244 10.2711 7.21732L14.7653 11.7115C14.8589 11.8051 14.925 11.9038 14.9634 12.0077C15.0019 12.1115 15.0211 12.2237 15.0211 12.3442C15.0211 12.4647 15.0019 12.5769 14.9634 12.6807C14.925 12.7846 14.8589 12.8833 14.7653 12.9769L10.2711 17.4711C10.1327 17.6096 9.95864 17.6804 9.74902 17.6836C9.53943 17.6868 9.36219 17.616 9.21733 17.4711C9.07244 17.3263 9 17.1506 9 16.9442C9 16.7378 9.07244 16.5622 9.21733 16.4173L13.2904 12.3442Z",
			fill: "#1C1B1F"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_374_3029)",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#333333"
		})
	})]
});
export default SvgNavigateNext;
